<template>
  <small-modal-container :is-visible="isVisible" :close-on-overlay="false">
    <div :class="$style.popup">
      <h2 :class="$style.title">이용약관이 개정되었어요</h2>
      <p :class="$style.description">
        로그인 회원 대상 안내입니다. 개정된 이용약관을 확인하신 뒤 계속 이용해
        주세요.
      </p>

      <div :class="$style.dateBox">
        <div><strong>공고일자</strong> {{ announcedDate }}</div>
        <div><strong>시행일자</strong> {{ effectiveDate }}</div>
      </div>

      <ul :class="$style.summaryList">
        <li>회원가입 및 계정 관련 안내가 구체화되었습니다.</li>
        <li>티켓 예매, 취소 및 환불 규정이 새로 추가되었습니다.</li>
        <li>서비스 제공 범위에 티켓 예매 내용이 반영되었습니다.</li>
      </ul>

      <p :class="$style.helperText">
        아래 버튼을 누르면 현재 개정 약관 확인 상태가 계정에 저장되며, 같은
        버전의 안내 팝업은 다시 표시되지 않습니다.
      </p>

      <div :class="$style.actions">
        <button type="button" :class="[$style.button, $style.secondaryButton]" @click="openTermsModal">
          전체 약관 보기
        </button>
        <button type="button" :class="[$style.button, $style.primaryButton]" :disabled="isSubmitting"
          @click="$emit('confirm')">
          {{ isSubmitting ? "저장 중..." : "확인했어요" }}
        </button>
      </div>
    </div>
  </small-modal-container>

  <terms-modal :is-visible="showTermsModal" @close="showTermsModal = false" />
</template>

<script>
import SmallModalContainer from "@/components/modal/SmallModalContainer.vue";
import TermsModal from "@/components/TermsModal.vue";
import {
  TERMS_NOTICE_ANNOUNCED_DATE,
  TERMS_NOTICE_EFFECTIVE_DATE,
} from "@/utils/termsNotice";

export default {
  name: "TermsNoticePopup",
  components: {
    SmallModalContainer,
    TermsModal,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["confirm"],
  data() {
    return {
      showTermsModal: false,
      announcedDate: TERMS_NOTICE_ANNOUNCED_DATE,
      effectiveDate: TERMS_NOTICE_EFFECTIVE_DATE,
    };
  },
  watch: {
    isVisible(newVal) {
      if (!newVal) {
        this.showTermsModal = false;
      }
    },
  },
  methods: {
    openTermsModal() {
      this.showTermsModal = true;
    },
  },
};
</script>

<style module>
.popup {
  padding: 28px 24px 24px;
}

.title {
  margin: 0 0 10px;
  font-size: 22px;
  font-weight: 700;
  color: #222;
  text-align: left;
}

.description {
  margin: 0 0 16px;
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
}

.dateBox {
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f6f8fb;
  color: #444;
  font-size: 13px;
  line-height: 1.6;
}

.summaryList {
  margin: 0 0 16px;
  padding-left: 18px;
  color: #444;
  font-size: 14px;
  line-height: 1.6;
}

.summaryList li {
  margin-bottom: 6px;
}

.helperText {
  margin: 0 0 20px;
  color: #777;
  font-size: 12px;
  line-height: 1.5;
  text-align: left;
}

.actions {
  display: flex;
  gap: 10px;
}

.button {
  flex: 1;
  border: none;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.secondaryButton {
  background: #f1f3f5;
  color: #444;
}

.secondaryButton:hover:not(:disabled) {
  background: #e9ecef;
}

.primaryButton {
  background: #66bdff;
  color: #fff;
}

.primaryButton:hover:not(:disabled) {
  background: #4aa8f2;
}

@media screen and (max-width: 480px) {
  .popup {
    padding: 24px 18px 18px;
  }

  .title {
    font-size: 20px;
  }

  .description,
  .summaryList {
    font-size: 13px;
  }

  .actions {
    flex-direction: column;
  }
}
</style>
